import * as THREE from "three";

// AE comp-space points need recentring (comp is measured from the top-left
// corner) and a Y/Z flip (AE's Y grows downward, Z grows into the screen —
// Three's convention is the opposite on both) before they mean anything as
// world-space Vector3s. Every position baked into scene.json passes through
// this once on load.
export function toThreeVector(p, compWidth, compHeight) {
  const cx = compWidth / 2;
  const cy = compHeight / 2;
  return new THREE.Vector3(p[0] - cx, -(p[1] - cy), -p[2]);
}
